
import { useMemo } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { USER_DETAILS_QUERY } from '../../queries/USER_DETAILS_QUERY';

export function useUserDetailsQuery( options ) {
    const { data: rawData, loading, error, client, refetch } = useQuery( USER_DETAILS_QUERY, {
        fetchPolicy: 'cache-first',
        ...options,
    } );

    return useMemo ( () => {
        return {
            error,
            loading,
            data: rawData,
            refetch,
            client,
        };
    }, [ rawData, loading, error, refetch ] );
}
